import ListCashPayments from "./List";
import { CASH_PAYMENTS, PaymentServicePath } from "utils/constants";
import permissions from "app/permissions";
import LocalAtmIcon from "@mui/icons-material/LocalAtm";

export const resources = {
  isMenu: true,
  icon: <LocalAtmIcon />,
  name: PaymentServicePath + CASH_PAYMENTS,
  title: "Касови плащания",
  list: <ListCashPayments />,
  permission: permissions.canPreviewCashPayments,
};
